export const IN_DAYS_COUNT_VALUE_LABEL_MAP = {
  0: 'general.appointments.today',
  1: 'general.appointments.tomorrow',
  2: 'general.appointments.dayAfterTomorrow',
}
